import { Helmet, HelmetProvider } from 'react-helmet-async';
import CareersHeroSection from '../components/Careers/CareersHeroSection'
import JobListings from '../components/Careers/JobListings'



const Careers = () => {
  return (
    <>
      <HelmetProvider>
      <Helmet>
        <title>Careers | Brand Acumen</title>
        <meta name="description" content="Explore the services offered by Brand Acumen." />
        <meta name="description" content="Welcome to the homepage of Brand Acumen." />
        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Home | Brand Acumen" />
        <meta property="og:description" content="Welcome to the homepage of Brand Acumen." />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:url" content="https://brandacumen.co/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Home | Brand Acumen" />
        <meta name="twitter:description" content="Welcome to the homepage of Brand Acumen." />
        <meta name="twitter:image" content="/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
      
      <CareersHeroSection />
      <JobListings />
      </HelmetProvider>
    </>
  );
};

export default Careers;